export default {"icons":{"iconfont":"mdiSvg"},"options":{"customProperties":true},"theme":{"options":{"minifyTheme":function (css) {
  return css.replace(/\n/g, '').replace(/\s\s+/g, ' ');
}},"themes":{"light":{"primary":"#00CCC0","secondary":"#F3F3F3","error":"#EB3E1B","warning":"#FD773D"}}}}
